declare let ENV: any;

import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
import './styles/index';

if (ENV === 'prod') {
    enableProdMode();
}

/*
 * Bootstrap Angular app with a top level component `App` and inject
 * Services and Providers into Angular's dependency injection
 */
export function main() {
    return platformBrowserDynamic()
        .bootstrapModule(AppModule)
        .then(() => console.info('Client app stated.'))
        .catch(err => console.error(err));
}

// bootstrap when document is ready
document.addEventListener('DOMContentLoaded', () => main());



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/main.browser.ts